import React, { FunctionComponent } from "react"
import { UserUsageReport } from "./ReportsTable"
import { TableRow, TableCell } from "@material-ui/core"
interface ReportsTableRowProps {
    report: UserUsageReport
}
export const ReportsTableRow: FunctionComponent<ReportsTableRowProps> = props => {
    const { report } = props

    return (
        <TableRow data-testid={`${report.id}-report`}>
            <TableCell id={`email${report.id}`} data-testid="email">
                {report.email}
            </TableCell>
            <TableCell id={`logins${report.id}`} data-testid="logins">
                {report.loginCount.toLocaleString("en-US")}
            </TableCell>
            <TableCell id={`translations${report.id}`} data-testid="translations">
                {report.translatedAudioCount.toLocaleString("en-US")}
            </TableCell>
            <TableCell id={`generatedAudio${report.id}`} data-testid="generatedAudio">
                {report.generatedAudioCount.toLocaleString("en-US")}
            </TableCell>
            <TableCell id={`audioFiles${report.id}`} data-testid="audioFiles">
                {report.approvedAudioCount.toLocaleString("en-US")}
            </TableCell>
            <TableCell id={`uploads${report.id}`} data-testid="uploads">
                {report.uploadedAudioCount.toLocaleString("en-US")}
            </TableCell>
        </TableRow>
    )
}
